import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AdminRoute from './components/AdminRoute';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ModeProvider } from './contexts/ModeContext';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Exercise from './pages/Exercise';
import ExerciseVersionManager from './pages/ExerciseVersionManager';
import AdminUsers from './pages/AdminUsers';
import Home from './pages/Home';
import LearningWiki from './pages/LearningWiki';
import Login from './pages/Login';
import Profile from './pages/Profile';
import ResetPassword from './pages/ResetPassword';
import SyncDashboard from './pages/SyncDashboard';

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ModeProvider>
          <Router>
            <Layout>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/login' element={<Login />} />
              <Route path='/auth/callback' element={<AuthCallback />} />
              <Route path='/reset-password' element={<ResetPassword />} />
              <Route
                path='/dashboard'
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/exercise/:id'
                element={
                  <ProtectedRoute>
                    <Exercise />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/profile'
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/wiki'
                element={
                  <ProtectedRoute>
                    <LearningWiki />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/admin/users'
                element={
                  <AdminRoute>
                    <AdminUsers />
                  </AdminRoute>
                }
              />
              <Route
                path='/admin/exercises'
                element={
                  <ProtectedRoute>
                    <ExerciseVersionManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/admin/sync'
                element={
                  <ProtectedRoute>
                    <SyncDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
        </Router>
        </ModeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
